class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.searchRequestId = 0;

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.searchRequestId += 1;
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm, ++this.searchRequestId);
  }

  getSearchResults(searchTerm, requestId) {
    const searchParams = new URLSearchParams({
      q: searchTerm,
      'resources[type]': 'query,product',
      'resources[limit]': '6',
      'resources[limit_scope]': 'each',
      section_id: 'predictive-search',
    });

    fetch(`${routes.predictive_search_url}?${searchParams.toString()}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        if (requestId !== this.searchRequestId || this.input.value.trim() !== searchTerm) return;

        const responseSection = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search');

        if (!responseSection) throw new Error('Predictive search section missing');

        const resultsMarkup = responseSection.innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.dataset.klaimPredictiveRelease = 'suggestions-quick-add-v1';
        this.open();
      })
      .catch((error) => {
        if (requestId !== this.searchRequestId) return;
        this.close(true);
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.input.setAttribute('aria-expanded', 'true');
  }

  close(clearResults = false) {
    if (clearResults) this.predictiveSearchResults.replaceChildren();
    this.predictiveSearchResults.style.removeProperty('display');
    this.input.setAttribute('aria-expanded', 'false');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
